import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CheckService } from 'src/app/checks/check.service';
import { intermediaryNumberValidator, phoneNumberValidator } from 'src/app/validators/custom-validators';
import { FormMessage } from 'src/app/ui-design-library/form-message/form-message.model';
import { Agent } from '../agent.model';
import { FormMessageComponent } from 'src/app/ui-design-library/form-message/form-message.component';
import { IconComponent } from 'src/app/ui-design-library/icon/icon.component';
import { InputFieldComponent } from 'src/app/ui-design-library/forms/input-field/input-field.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'fnsr-agent-create',
  standalone: true,
  imports: [FormMessageComponent, IconComponent, ReactiveFormsModule, InputFieldComponent, NgClass],
  templateUrl: './agent-create.component.html'
})
export class AgentCreateComponent implements OnInit {
  form!: FormGroup;
  isValidatingEmail = false;
  isLoading = false;
  buttonText = 'Anlegen';
  formMessage?: FormMessage;

  constructor(
    public fb: FormBuilder,
    public checkService: CheckService,
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  private createForm(): void {
    this.form = this.fb.group({
      phoneNumber: ['', {
        validators: [
          Validators.required,
          phoneNumberValidator
        ],
      }],
      IntermediaryNumberInvalid: ['', {
        validators: [
          Validators.required,
          intermediaryNumberValidator
        ],
        updateOn: 'blur'
      }],
    })
  }

  // private checkEmailAvailable(control: FormControl): any {
  //   this.isValidatingEmail = true;
  //   const email = control.value;

  //   return this.checkService.checkEmailAvailable(email).pipe(
  //     map(
  //       result => {
  //         this.isValidatingEmail = false;
  //         if (result.emailAvailable) {
  //           return { emailNotAvailable: true };
  //         }
  //         return null;
  //       },
  //       (err: Error) => {
  //         console.log(err);
  //         this.isValidatingEmail = false;
  //       }
  //     )
  //   );
  // }

  // private checkEmailForBarmeniaDomain(control: FormControl): any {
  //   this.isValidatingEmail = true;
  //   const email = control.value;

  //   return this.checkService.checkEmailForBarmeniaDomain(email).pipe(
  //     map(
  //       result => {
  //         this.isValidatingEmail = false;
  //         if (!result.hasBarmeniaDomain) {
  //           return { noBarmeniaDomain: true };
  //         }
  //         return null;
  //       },
  //       (err: Error) => {
  //         console.log(err);
  //         this.isValidatingEmail = false;
  //       }
  //     )
  //   );
  // }

  onSubmit(value: Agent) {
    console.log(value);
  }

  resetForm() {
    this.isLoading = false;
    this.buttonText = 'Anlegen';
    delete this.formMessage;
    this.form?.reset();
  }
}
